import React from 'react';
import { VStack, HStack, Text, Badge, useColorModeValue } from '@chakra-ui/react';
import { ARIVE_TRACKER_NAMES } from '../../../constants/ariveConstants';

const STATUS_COLORS = {
  NOT_ORDERED: 'gray',
  ORDERED: 'blue',
  RECEIVED: 'green',
  REVIEWED: 'green',
  SENT: 'blue',
  SIGNED: 'green',
  APPROVED: 'green',
  COMPLETE: 'green',
  PENDING: 'yellow',
  ISSUE: 'red',
};

function getStatusColor(statusName) {
  if (!statusName) return 'gray';
  const upper = statusName.toUpperCase().replace(/\s+/g, '_');
  for (const [key, color] of Object.entries(STATUS_COLORS)) {
    if (upper.includes(key)) return color;
  }
  return 'gray';
}

export default function AriveTrackersCard({ trackers }) {
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  if (!trackers || trackers.length === 0) {
    return <Text fontSize="xs" color={mutedColor}>No trackers available</Text>;
  }

  return (
    <VStack align="stretch" spacing={1}>
      {trackers.map((t) => (
        <HStack key={t.name} justify="space-between">
          <Text fontSize="xs" color={mutedColor}>
            {ARIVE_TRACKER_NAMES[t.name] || t.displayName || t.name}
          </Text>
          <Badge fontSize="10px" colorScheme={getStatusColor(t.currentTrackerStatus?.name)}>
            {t.currentTrackerStatus?.displayName || t.currentTrackerStatus?.name || 'Unknown'}
          </Badge>
        </HStack>
      ))}
    </VStack>
  );
}
